import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';

@Component({
  selector: 'prgov-dialog-possible-witnesses',
  templateUrl: './dialog-possible-witnesses.component.html',
  styleUrls: ['./dialog-possible-witnesses.component.scss'],
})
export class DialogPossibleWitnessesComponent {
  title = '';
  okText = '';
  closeText = '';
  form: FormGroup;
  langKey: any = 'SELECTED_LANGUAGE';
  constructor(
    public dialogRef: MatDialogRef<DialogPossibleWitnessesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public ls: LsHelperService,
  ) {
    translate.use(this.ls.get(this.langKey));

    this.title = this.data.title;
    this.okText = this.data.okText;
    this.closeText = this.data.closeText;

    this.form = this.formBuilder.group({
      Id: [this.data.item ? this.data.item.Id : 1],
      Name: [this.data.item ? this.data.item.Name : '', Validators.compose([Validators.required])],
      TelephoneNumber: [this.data.item ? this.data.item.TelephoneNumber : '', Validators.compose([Validators.required])],
      Email: [
        this.data.item ? this.data.item.Email : '',
        Validators.compose(
          [
            Validators.email,
            Validators.maxLength(70),
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
          ])
      ]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
